module.exports = __webpack_public_path__ + "img/zixun.9bc0b072.svg";